import type { RuntimeConfig } from '../types/api';

let runtimeConfig: RuntimeConfig | null = null;

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (runtimeConfig) return runtimeConfig;
  const res = await fetch('/runtime-config.json');
  if (!res.ok) throw new Error('Failed to load runtime config');
  runtimeConfig = await res.json();
  return runtimeConfig!;
}

export function getRuntimeConfig(): RuntimeConfig {
  if (!runtimeConfig) throw new Error('Runtime config not loaded');
  return runtimeConfig;
}
